import { useEffect, useState } from "react";
import { Zap, Loader2 } from "lucide-react";

// "Salvataggio rapido": only machine type + hourly rate; every other field
// keeps the category defaults and can be completed later from the card.
export default function QuickMachineSave({ categories, onSave, t }) {
  const generic = categories.filter((c) => !c.brand);
  const [categoryId, setCategoryId] = useState("");
  const [rate, setRate] = useState("");
  const [rateTouched, setRateTouched] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const selected = generic.find((c) => c.id === categoryId);

  useEffect(() => {
    if (!categoryId && generic.length) setCategoryId(generic[0].id);
  }, [generic, categoryId]);
  useEffect(() => {
    // Category default only until the user types a rate of their own.
    if (selected && !rateTouched) setRate(String(selected.hourly_rate ?? ""));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId]);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    const value = parseFloat(String(rate).replace(",", "."));
    if (!selected || !(value > 0)) { setError(t("machines.quickRateError")); return; }
    setBusy(true);
    setError((await onSave(selected, value)) || "");
    setBusy(false);
  };

  return (
    <form onSubmit={submit} className="tech-card p-5 mb-6" data-testid="quick-machine-form">
      <div className="flex items-center gap-2 font-display font-semibold text-slate-100">
        <Zap size={16} className="text-amber-400"/> {t("machines.quickTitle")}
      </div>
      <p className="text-xs text-slate-400 mt-1 mb-4">{t("machines.quickHint")}</p>
      <div className="grid grid-cols-1 sm:grid-cols-[1fr_170px_auto] gap-3 items-end">
        <div>
          <label className="label-tech block mb-2">{t("machines.category")}</label>
          <select value={categoryId} onChange={(e) => setCategoryId(e.target.value)} className="w-full px-4 py-3 rounded-md text-sm" data-testid="quick-category">
            {generic.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>
        <div>
          <label className="label-tech block mb-2">{t("machines.hourlyRate")}</label>
          <input type="text" inputMode="decimal" value={rate} onChange={(e) => { setRate(e.target.value); setRateTouched(true); }} className="w-full px-4 py-3 rounded-md text-sm" data-testid="quick-rate"/>
        </div>
        <button type="submit" disabled={busy || !selected} className="btn-primary px-5 py-3 rounded-md flex items-center justify-center gap-2 disabled:opacity-60" data-testid="quick-save-btn">
          {busy ? <Loader2 size={14} className="animate-spin"/> : <Zap size={14}/>} {t("machines.quickSave")}
        </button>
      </div>
      {error && <div className="mt-3 text-sm text-red-400" data-testid="quick-save-error">{error}</div>}
    </form>
  );
}
